import React from 'react';
const Metdata = props => {
    const videoIcon = () => (
        <svg className="video-icon" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 15.3442V1.65585C1 1.13717 1.53687 0.824411 1.94413 1.10584L12.2585 8.23352C12.6401 8.49719 12.6296 9.09798 12.2392 9.34633L1.92482 15.907C1.51685 16.1665 1 15.852 1 15.3442Z"
                stroke="#1C3938" stroke-width="1.5"/>
        </svg>
    );

    const articleIcon = () => (
        <svg className="article-icon" width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 0.669983H19V19.67H0V0.669983ZM1.9 2.56998H17.1V17.77H1.9V2.56998ZM13.68 5.22998H3.61V7.12998H13.68V5.22998ZM15.01 9.21997H3.61V11.12H15.01V9.21997ZM3.61 13.21H11.97V15.11H3.61V13.21ZM14.4681 15.3562C15.1132 15.3562 15.6362 14.8332 15.6362 14.1881C15.6362 13.543 15.1132 13.02 14.4681 13.02C13.823 13.02 13.3 13.543 13.3 14.1881C13.3 14.8332 13.823 15.3562 14.4681 15.3562Z"
                fill="#1C3938"/>
        </svg>
    );

    return (
        <div className="metadata-container">
            <h2 className="h3">
                {props.contentType === `article` ? articleIcon() : videoIcon()}
                {props.data.title}
            </h2>
            <p className="author">{props.data.publisher}</p>
        </div>
    );
};

export default Metdata;
